import React from 'react';

export const Logo = ({ className, ariaLabel = "Stock Investing Pro Logo" }: { className?: string, ariaLabel?: string }) => (
  <div className={className} role="img" aria-label={ariaLabel}>
    <img 
      src="/StockInvestingLogo.webp"
      alt={ariaLabel}
      width={338}
      height={60}
      className="w-full h-full aspect-[338/60] object-contain"
      loading="eager"
      decoding="async"
    />
  </div>
);
